document.addEventListener('DOMContentLoaded', function () {
   collection_rec_slider_btn();

});
document.addEventListener('DOMContentLoaded', function () {
   initRelatedSlider();

});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-menu > details > summary.header__menu-item ').forEach(span => {
    span.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // closest header-menu
      const headerMenu = span.closest('header-menu');
      if (!headerMenu) return;

      // open ALL details inside this header-menu
      headerMenu.querySelectorAll('details').forEach(details => {
         details.toggleAttribute('open')
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-menu > details > ul > li > details >  summary.header__menu-item ').forEach(span => {
    span.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // closest header-menu
   

      // open ALL details inside this header-menu
     
    });
  });
});
// you may also like sectin slider cstm btn 
// function collection_rec_slider_btn(){

//     document.querySelectorAll('.rec-slider-prev').forEach(btn => {
//         btn.addEventListener('click', function () {
           
//             const slickPrevBtn = document.querySelector('.collection-cstm-slider .slick-prev');
//             if (slickPrevBtn) {
//                 slickPrevBtn.click();
//             }
//         });
//     });
//     document.querySelectorAll('.rec-slider-next').forEach(btn => {
//         btn.addEventListener('click', function () {
           
//             const slickNextBtn = document.querySelector('.collection-cstm-slider .slick-next');
//             if (slickNextBtn) {
//                 slickNextBtn.click();
//             }
//         });
//     });
// }


//header.liquid section rendring api

// update cart number after add to cart 

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-form__submit').forEach((e)=>{
    e.addEventListener('click',function(){
      setTimeout(() => {
     fetch(window.location.pathname + '?sections=header')
  .then(response => response.json())
  .then(data => {
    // console.log(data.header);
     const doc = new DOMParser().parseFromString(data.header, 'text/html');
    document.querySelector('#cart-icon-bubble').innerHTML =
      doc.querySelector('#cart-icon-bubble').innerHTML;
  });
  }, 1000);

    });
  });
});



// slider arrows
$(document).ready(function(){

  var $gallery = $('[id^="Slider-Gallery-"]');
  var $slides = $gallery.find('.slider__slide');
  var total = $slides.length;
  var index = $slides.filter('.is-active').index();

  if(index < 0) index = 0;

  function goToSlide(i){

    if(i < 0) i = total - 1;
    if(i >= total) i = 0;

    index = i;

    var $target = $slides.eq(index);

    $slides.removeClass('is-active');
    $target.addClass('is-active');

    $gallery.animate({
      scrollLeft: $target.position().left + $gallery.scrollLeft()
    }, 400);

    $('.slider-counter--current').text(index + 1);
  }

  $('.slider-button--next').on('click', function(){
    goToSlide(index + 1);
  });

  $('.slider-button--prev').on('click', function(){
    goToSlide(index - 1);
  });

});

